export const runtimeConfig =
  typeof window !== 'undefined'
    ? {
        publicPath: window.env.publicPath,
        bffURL: window.env.bffURL,
        googleKey: window.env.googleKey,
        gtmContainerKey: window.env.gtmContainerKey,
        gtmURL: window.env.gtmURL,
        timeout: window.env.timeout,
        env: window.env.environment,
        encrypted: window.env.encrypted,
        sellerCreditFacilityUrl: window.env.sellerCreditFacilityUrl,
        sellerCheckingCreditUrl: window.env.sellerCheckingCreditUrl,
        sellerCheckingCreditWithAccountUrl: window.env.sellerCheckingCreditWithAccountUrl,
        metrixUri: window.env.metrixUri,
        orgId: window.env.orgId,
        secretKeyRedux: window.env.secretKeyRedux,
        withdrawalLimitFullProfile: window.env.withdrawalLimitFullProfile,
        transactionsFilterCodeAdvancements: window.env.transactionsFilterCodeAdvancements,
        withdrawalLimitIncompleteProfile: window.env.withdrawalLimitIncompleteProfile,
        transactionsPerPage: window.env.transactionsPerPage,
        country: window.env.country,
        datamartOB: window.env.datamartOB,
        isAvailableWidget: window.env.isAvailableWidget,
        urlScriptFinancingBanners: window.env.urlScriptFinancingBanners,
        widgetScript: window.env.widgetScript,
        widgetEvent: window.env.widgetEvent,
        widgetTag: window.env.widgetTag,
        version: window.env.version,
        enabledBlockingFundsOutForAll: window.env.enabledBlockingFundsOutForAll,
        avoidPromotionValidation: window.env.avoidPromotionValidation,
        pismoCallTimeout: window.env.pismoCallTimeout,
        advancementRequestLimit: window.env.advancementRequestLimit,
        promotionTokenTimeout: window.env.promotionTokenTimeout,
        notificationBulletColor: window.env.notificationBulletColor,
        paymentMethodsValidToRefund: window.env.paymentMethodsValidToRefund,
        balancesWindowDays: Number(window.env.balancesWindowDays),
        daysMovementsMax: window.env?.daysMovementsMax,
        showPaymentDateColumn: window.env.showPaymentDateColumn,
        publicKey: window.env.publicKey,
      }
    : {
        publicPath: process.env.RAZZLE_BASE_PUBLIC_PATH || '',
        bffURL: process.env.RAZZLE_BFF_BASE || 'https://payments-backoffice-qa.fpayapp.com',
        googleKey: process.env.RAZZLE_GOOGLE_PLACES_KEY || 'GOOGLE-PLACES-KEY',
        gtmContainerKey: process.env.RAZZLE_GTM_CONTAINER_KEY || 'GTM-5P5CWHB',
        gtmURL: process.env.RAZZLE_GTM_URL || 'https://www.googletagmanager.com/gtm.js',
        timeout: process.env.RAZZLE_TIMEOUT_SERVICE || 30000,
        environment: process.env.RAZZLE_NODE_ENV || 'local',
        encrypted: !!process.env.RAZZLE_ENCRYPTED,
        sellerCreditFacilityUrl:
          process.env.RAZZLE_SELLER_CREDIT_FACILITY_URL ||
          'https://qa.widget.falabella.edatamart.co/falabella/seller-cl/creditfacility/seller/falabella-seller-cl@1.0.0.js',
        sellerCheckingCreditUrl:
          process.env.RAZZLE_SELLER_CHECKING_CREDIT_URL ||
          'https://homo.widget.falabella.datamart.co/falabella/sellers/credits/falabella-sellers-credits-wid-0.1.0.js',
        sellerCheckingCreditWithAccountUrl:
          process.env.RAZZLE_SELLER_CHECKING_CREDIT_WITH_ACCOUNT_URL ||
          'https://homo.widget.falabella.datamart.co/falabella/sellers/credits/falabella-sellers-credits-wid-0.1.0.js',
        metrixUri: process.env.RAZZLE_METRIX_URI || 'https://h.online-metrix.net',
        orgId: process.env.RAZZLE_ORG_ID || 'k8vif92e',
        secretKeyRedux: process.env.RAZZLE_SECRET_KEY_REDUX || null,
        withdrawalLimitFullProfile: process.env.RAZZLE_WITHDRAWAL_LIMIT_FULL_PROFILE || 7000000,
        transactionsFilterCodeAdvancements:
          process.env.RAZZLE_TRANSACTIONS_FILTER_CODE_ADVANCEMENTS || '',
        withdrawalLimitIncompleteProfile:
          process.env.RAZZLE_WITHDRAWAL_LIMIT_INCOMPLETE_PROFILE || 500000,
        transactionsPerPage: process.env.RAZZLE_PER_PAGE_TRANSACTIONS || '1000',
        country: process.env.RAZZLE_COUNTRY || 'cl',
        datamartOB:
          process.env.RAZZLE_DATAMART_OB ||
          'https://dev.widget.falabella.edatamart.co/falabella/onboarding/kyb/enroll/falabella-seller-cl@1.0.0.js',
        isAvailableWidget:
          process.env.RAZZLE_SELLER_AVAILABLE_PROMOTIONS !== undefined
            ? JSON.parse(process.env.RAZZLE_SELLER_AVAILABLE_PROMOTIONS)
            : {
                CHECKING_CREDIT: [
                  { process: 'OFFERING', state: 'APPROVED' },
                  { process: 'OFFERING', state: 'PRE_APPROVED' },
                  { process: 'OFFERING', state: 'INCREASE_APPROVED' },
                  { process: 'ORIGINATION', state: 'APPROVED' },
                  { process: 'ORIGINATION', state: 'PENDING' },
                  { process: 'CLOSING', state: 'PENDING' },
                  { process: 'CLOSING', state: 'COMPLETED' },
                  { process: 'PROVISIONING', state: 'COMPLETED' },
                  { process: 'PROVISIONING', state: 'PENDING' },
                ],
                CHECKING_CREDIT_WITH_ACCOUNT: [
                  { process: 'OFFERING', state: 'APPROVED' },
                  { process: 'OFFERING', state: 'PRE_APPROVED' },
                  { process: 'OFFERING', state: 'INCREASE_APPROVED' },
                  { process: 'ORIGINATION', state: 'APPROVED' },
                  { process: 'ORIGINATION', state: 'PENDING' },
                  { process: 'CLOSING', state: 'PENDING' },
                  { process: 'CLOSING', state: 'COMPLETED' },
                  { process: 'PROVISIONING', state: 'COMPLETED' },
                  { process: 'PROVISIONING', state: 'PENDING' },
                ],
                CREDIT_FACILITY: [
                  { process: 'OFFERING', state: 'APPROVED' },
                  { process: 'OFFERING', state: 'PRE_APPROVED' },
                  { process: 'OFFERING', state: 'INCREASE_APPROVED' },
                  { process: 'ORIGINATION', state: 'APPROVED' },
                  { process: 'ORIGINATION', state: 'PENDING' },
                  { process: 'CLOSING', state: 'PENDING' },
                  { process: 'CLOSING', state: 'COMPLETED' },
                  { process: 'PROVISIONING', state: 'COMPLETED' },
                  { process: 'PROVISIONING', state: 'PENDING' },
                ],
              },
        urlScriptFinancingBanners:
          process.env.RAZZLE_FINANCING_BANNERS_SCRIPT_URL ||
          'https://payments-backoffice-qa.fpayapp.com/andes/bff/promotions/int/financingBanners.js',
        widgetScript:
          process.env.RAZZLE_WIDGET_SCRIPT ||
          'https://apollo-public.loyal.ink/survey/ZnBheS90ZXN0.js',
        widgetEvent: process.env.RAZZLE_WIDGET_EVENT || 'testfpay',
        widgetTag: process.env.RAZZLE_WIDGET_TAG || 'apollo-ZnBheS90ZXN0',
        version: process.env.RAZZLE_APP_VERSION || '1.3',
        enabledBlockingFundsOutForAll:
          process.env.RAZZLE_ENABLE_BLOCKING__FUNDS_OUT_FOR_ALL || 'false',
        avoidPromotionValidation: process.env.RAZZLE_AVOID_PROMOTION_VALIDATION || 'false',
        pismoCallTimeout: process.env.RAZZLE_PISMO_CALL_TIMEOUT || 1500,
        advancementRequestLimit: process.env.RAZZLE_ADVANCEMENT_REQUEST_LIMIT || 2,
        promotionTokenTimeout: process.env.RAZZLE_PROMOTION_TOKEN_TIMEOUT || 15000,
        notificationBulletColor: process.env.RAZZLE_NOTIFICATION_BULLET_COLOR || '#FF9900',
        paymentMethodsValidToRefund:
          process.env.RAZZLE_PAYMENT_METHODS_VALID_TO_REFUND !== undefined
            ? JSON.parse(process.env.RAZZLE_PAYMENT_METHODS_VALID_TO_REFUND)
            : ['debit', 'credit'],
        balancesWindowDays: Number(process.env.RAZZLE_BALANCES_WINDOW_DAYS || 16),
        daysMovementsMax: Number(process.env.RAZZLE_DAYS_MOVEMENTS_MAX || 89),
        showPaymentDateColumn: process.env.RAZZLE_SHOW_PAYMENT_DATE_COLUMN || 'false',
        publicKey:
          process.env.RAZZLE_PUBLIC_KEY ||
          '-----BEGIN PUBLIC KEY-----',
      };

export const getEnv = () => runtimeConfig;
